import React, { useEffect, useState } from "react";
import DataTableHelper from "../../../helpers/tables/DataTableHelper";
import Columns from "./Columns";
import PreviewPDF from "../../../helpers/previewPDF";
import {
  getRouteConfigs,
  resourcesPayroll,
  resourcesReports,
} from "../../../helpers/backend_helper";
import { getStorageUser } from "../../../helpers/api_helper";
import { Button, Container } from "reactstrap";
import ButtonHelper from "../../../helpers/ButtonHelper";
import * as dayjs from "dayjs";
import ConfigModal from "./ConfigModal";

const today = dayjs();

const CumplimientoVeladas = () => {
  const authUser = getStorageUser();
  const [pending, setPending] = useState(false);
  const [horarioVelada, setHorarioVelada] = useState(null);
  const [modal, setModal] = useState({ show: false, update: false });
  const [modalPdf, setModalPdf] = useState({ show: false, update: false });
  const [modalPrice, setModalPrice] = useState({ show: false, update: false });
  const [dataPag, setDataPag] = useState({ total: 0 });
  const [filters, setFilters] = useState({
    page: 1,
    perPage: 20,
    search: "",
    orderBy: "key",
    order: "asc",
    companySession: authUser.company_id,
    date: dayjs().subtract(1, 'day').format("YYYY-MM-DD"),
  });
  const [items, setItems] = useState([]);
  const itemBase = {
    id: null,
    date: null,
    unit_id: null,
    notes: null,
    amount: null,
    total: null,
    operator_id: null,
    unit_id: null,
    salidas_count: null,
  };
  const [item, setItem] = useState(itemBase);

  useEffect(() => {
    if (!horarioVelada) return;

    setPending(true);

    const config = {
      params: {
        ...filters,
        horarioVelada,
      },
    };

    resourcesReports("show", config, "cumplimientoVeladasReport")
      .then((response) => {
        setItems(response.salidas);
      })
      .finally(() => setPending(false));
  }, [horarioVelada, filters]);

  const addUpd = (row) => {
    console.log("row", row);
    if (row?.id) {
      setItem({
        ...row,
        date: dayjs(row.date.substr(0, 10)).format("YYYY-MM-DD"),
      });
      setModal({ ...modal, show: true, update: true });
    } else {
      setItem({ ...itemBase });
      setModal({ ...modal, show: true, update: false });
    }
  };

  const print = (row) => {
    const params = {
      params: { initDate: filters.initDate, endDate: filters.endDate },
      headers: { Accept: "application/pdf" },
      responseType: "blob",
    };
    resourcesPayroll("show", params, row.id).then((response) => {
      let nombre = "Archivo";
      var reader = new FileReader();
      reader.readAsDataURL(response);
      reader.fileName = nombre[1] || nombre[0];
      reader.onloadend = function (name) {
        name = nombre[0];
        var base64data = reader.result;
        setModalPdf({ show: true, update: false, url: base64data });
      };
    });
  };

  const getReports = (type) => {
    let config = {
      params: {
        ...filters,
        horarioVelada,
      },
      headers: {
        Accept:
          type == 2
            ? "application/pdf"
            : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      },
      responseType: "blob",
    };
    resourcesReports("show", config, "cumplimientoVeladasReport").then(
      (response) => {
        if (type == 1) {
          const url = URL.createObjectURL(new Blob([response]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "CumplimientoVeladas.xlsx");
          document.body.appendChild(link);
          link.click();
        } else {
          let nombre = "Archivo";
          var reader = new FileReader();
          reader.readAsDataURL(response);
          reader.fileName = nombre[1] || nombre[0];
          reader.onloadend = function (name) {
            name = nombre[0];
            var base64data = reader.result;
            setModalPdf({ show: true, update: false, url: base64data });
          };
        }
      }
    );
  };

  useEffect(() => {
    const fetchConfigs = async () => {
      const response = await getRouteConfigs();

      const horarioVeladaConfig = response.filter(
        (e) => e.configuration_id == 25
      );
      setHorarioVelada(horarioVeladaConfig[0]?.value ?? null);
    };

    fetchConfigs();
  }, []);

  const completeConfigHandler = () => {
    setModalPrice({ show: false });
    setFilters({ ...filters });
  };

  const columns = Columns(print);
  document.title = "Cumplimiento Veladas | Sistema de logística";
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div className="col-12">
            <DataTableHelper
              filterInp={false}
              tittle="Cumplimiento Veladas"
              columns={columns}
              items={items}
              pending={pending}
              config={dataPag}
              filters={filters}
              setFilters={setFilters}
              pagination={false}
            >
              <div className="col-md-3">
                <div className="form-label mb-0">
                  <label>Seleccionar día:</label>
                  <input
                    className="form-control"
                    type="date"
                    id="date"
                    name="date"
                    value={filters.date}
                    onChange={({ target }) => {
                      const date = target.value;

                      if (!date) return;

                      setFilters((prev) => ({
                        ...prev,
                        date,
                      }));
                    }}
                  />
                </div>
              </div>
              <div className="col-md-9">
                <div className="mb-3">
                  <ButtonHelper
                    actionSave={addUpd}
                    addButon={false}
                    reportButons={true}
                    actionReportButon={getReports}
                    actionAddButon={() => addUpd()}
                  >
                    <Button
                      className="btn-sm float-end me-2"
                      type="button"
                      value={"Config"}
                      onClick={(e) =>
                        setModalPrice({ ...modalPrice, show: true })
                      }
                    >
                      <i className="fa fa-cogs"></i> Configurar
                    </Button>
                  </ButtonHelper>
                </div>
              </div>
            </DataTableHelper>
          </div>
        </Container>
        {modalPdf.show && (
          <PreviewPDF
            title="Recibo de Nómina"
            modalPdf={modalPdf}
            setModalPdf={setModalPdf}
          />
        )}
        {modalPrice.show && (
          <ConfigModal
            modal={modalPrice}
            setModal={setModalPrice}
            completeHandler={completeConfigHandler}
            horarioVelada={horarioVelada}
            setHorarioVelada={setHorarioVelada}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default CumplimientoVeladas;
